// Module
var code = "<template>\n    <require from=\"./input-checkbox.scss\"></require>\n    <label>\n        <input type=\"checkbox\" name=\"${fieldName}\" value.bind=\"value\" checked.two-way=\"value\" disabled.bind=\"disabled\" />\n        <span class=\"answer\"></span>\n        ${label}\n    </label>\n    ${validationMessage}\n</template>\n";
// Exports
export default code;